<template>
    <div>
        <PageTitle :title="$t('ayuda.contacto')" class="strech"/>

        <section v-if="!isSuccess" class="login-section">
            <div class="thumb-container absolute" :style="`background-image: url(${footer.bg4_url})`"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-8 col-xl-5">
                        <div class="has-header d-flex">
                            <div class="form-content form-team-content w-100 white-content">

                                <ValidationObserver tag="form" ref="formObserver" @submit.prevent="handleFormSubmit">
                                    <div class="form-group">
                                        <FormInput
                                            :label="$t('ayuda.email')"
                                            type="email"
                                            name="email"
                                            id="email"
                                            rules="required|email"
                                            v-model="formData.email"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <FormInput
                                            :label="$t('ayuda.title')"
                                            type="text"
                                            name="titulo"
                                            id="titulo"
                                            rules="required"
                                            v-model="formData.subject"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="message">{{ $t('ayuda.message') }}</label>
                                        <ValidationProvider name="message" rules="required" v-slot="{ errors }">
                                            <textarea
                                                id="message"
                                                v-model="formData.message"
                                                :placeholder="$t('ayuda.message')"
                                                class="form-control"
                                                :class="{ 'is-invalid': errors[0] }"
                                                maxlength="500"
                                                minlength="8"
                                            ></textarea>
                                            <span v-if="errors[0]" class="error invalid-feedback d-block">
                                                {{ errors[0] }}
                                            </span>
                                        </ValidationProvider>
                                    </div>

                                    <div class="row justify-content-center">
                                        <FormCaptchaComponent
                                            :siteKey="sitekey"
                                            @success="onCaptchaVerified"
                                        />
                                    </div>

                                    <div class="row justify-content-md-between mt-3">
                                        <div class="col-12">
                                            <button
                                                :disabled="!canSubmit || isSending"
                                                type="submit"
                                                class="button btn-block"
                                                name="button"
                                            >
                                                <span v-if="isSending" class="spinner-border spinner-border-sm mr-1"></span>
                                                {{ $t('ayuda.enviar') }}
                                            </button>
                                        </div>
                                    </div>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <Gracias :color="footer.bg4_url" v-else />
    </div>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue';
    import { t } from '@/utils/i18n-helper';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FormCaptchaComponent from '@/modules/ui/FormCaptchaComponent.vue';
    import Gracias from '@/components/frontend/ayuda/Gracias';

    import { useContactForm } from '@/composables/front/contact/useContactForm';

    const {
        formData,
        isSending,
        isSuccess,
        footer,
        sitekey,
        onCaptchaVerified,
        submitMessage,
        canSubmit
    } = useContactForm();

    const formObserver = ref(null);
    const instance = getCurrentInstance();
    const toast = instance.proxy.$toast;

    const handleFormSubmit = async() => {
        const isValid = await formObserver.value.validate();

        if (isValid) {
            try {
                await submitMessage();
                toast.success(t('ayuda.email_enviado'));
            } catch (error) {
                toast.error(t('ayuda.error_envio'));
            }
        }
    };
</script>
